import api from "../api"
import { DatatableResults } from "../../common/datatables"
import { buildVisitsRequestBody } from "./customerVisitsModel"

export type CustomerVisit = {
  id: string
  date: string
  createdByEmail: string
  project: {
    type: number
    name: string
  }
}

export const getCustomerVisits = async (
  customerId: number,
  page: number,
  pageSize: number
): Promise<DatatableResults<CustomerVisit>> => {
  const body = buildVisitsRequestBody({ draw: page, start: (page - 1) * pageSize, length: pageSize })
  return (await api.post<DatatableResults<CustomerVisit>>(`/v2/time/cards/dynamic?customerId=${customerId}`, body)).data
}
